import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'
import { HeroSection } from '@/components/sections/HeroSection'
import { CompanyHistory } from '@/components/sections/CompanyHistory'
import { LocalizedLink } from '@/components/LocalizedLink'
import { ArrowRight } from 'lucide-react'

export default function About() {
  const { t, i18n } = useTranslation('common')

  return (
    <>
      <Helmet>
        <title>{t('about.seo.title')}</title>
        <meta name="description" content={t('about.seo.description')} />
        <html lang={i18n.language} />
      </Helmet>

      <HeroSection
        imageSrc="/images/history-founder.jpg"
        title={t('about.hero.title')}
        slogan={t('about.hero.slogan')}
        primaryCta={{ label: t('buttons.contactUs'), to: 'contacts' }}
        secondaryCta={{ label: t('nav.services'), to: 'services' }}
      />

      <CompanyHistory />

      {/* CTA Section */}
      <section className="bg-brand-red py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('home.cta.heading')}
          </h2>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            {t('home.cta.body')}
          </p>
          <LocalizedLink
            to="contacts"
            className="group inline-flex items-center gap-2 bg-white text-brand-red font-bold py-3 px-8 rounded-lg hover:bg-gray-100 transition-colors"
          >
            {t('buttons.contactUs')}
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </LocalizedLink>
        </div>
      </section>
    </>
  )
}
